<script setup lang="ts">
import { nextTick, onMounted } from 'vue';
// import { useMetronic } from './composables/useMetronic';
import { useWhitelabel } from './composables/useWhitelabel';
import KTComponent from './metronic/core/index';
import KTLayout from './metronic/app/layouts/demo1';

// Inicializar o Metronic
// useMetronic();

onMounted(async () => {
	// Inicializar whitelabel primeiro para aplicar temas
	const whitelabel = useWhitelabel();
	whitelabel.applyWhitelabelStyles();

	nextTick(() => {
		KTComponent.init();
		KTLayout.init();
	});
});
</script>

<template>
	<div id="app">
		<router-view />
	</div>
</template>

<style>
#app {
	height: 100vh;
	overflow: hidden;
}
</style>
